import { render, staticRenderFns } from "./user-area.vue?vue&type=template&id=4de5a228&scoped=true"
import script from "./user-area.vue?vue&type=script&lang=js"
export * from "./user-area.vue?vue&type=script&lang=js"
import style0 from "./user-area.vue?vue&type=style&index=0&id=4de5a228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5a228",
  null
  
)

export default component.exports